import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogContent, MatDialogActions, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { MatFormField, MatInputModule, MatLabel } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-check-impossible-dialog',
  imports: [MatDialogContent, MatDialogTitle, MatFormField, MatLabel, MatDialogActions, MatInputModule, MatButtonModule, FormsModule, MatIcon],
  templateUrl: './check-impossible-dialog.html',
  styleUrl: './check-impossible-dialog.scss',
})
export class CheckImpossibleDialog {
  readonly dialog = inject(MatDialogRef<CheckImpossibleDialog>);
  commentText = '';

  saveReason() {
    if (!this.commentText.trim()) return;
    this.dialog.close(this.commentText.trim());
  }

  closeDialog(): void {
    this.dialog.close();
  }

}
